export default "__VITE_ASSET__W95RrjrW__"